<template>
  <div @click="redirect">
    <md-card class="md-card-stats" :md-with-hover="to !== null">
      <md-card-header
        class="md-card-header-icon"
        :class="getClass(headerColor)"
      >
        <slot name="header"></slot>
      </md-card-header>

      <md-card-actions
        md-alignment="left"
        :style="{ borderWidth: $slots.footer ? 1 : 0 }"
      >
        <slot name="footer"></slot>
      </md-card-actions>
    </md-card>
  </div>
</template>
<script>
export default {
  name: "stats-card",
  props: {
    headerColor: {
      type: String,
      default: ""
    },
    to: {
      type: Object,
      default() {
        return null;
      }
    }
  },
  methods: {
    getClass: function(headerColor) {
      return "md-card-header-" + headerColor + "";
    },
    redirect() {
      if (this.to) {
        this.$router.push(this.to);
      }
    }
  }
};
</script>
